import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c3095a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "quizz-awards row"
}
const _hoisted_2 = { class: "col-12 col-lg-6 illustration-side" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col-12 col-lg-6 description-side" }
const _hoisted_5 = ["innerHTML"]

import PageContainer from '@/components/PageContainer.vue'
import ScreenPath from '@/components/ScreenPath.vue'
import { awards } from '@/data/awards'
import { useStoreQuizz } from '@/stores/quizz'
import { computed } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quizzStore = useStoreQuizz()
const router = useRouter()

const award = computed(() =>
  awards.find((award) => award.medal === quizzStore.currentMedal)
)

function goToHome() {
  router.replace('/modules-choice')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContainer, null, {
    default: _withCtx(() => [
      (_unref(award))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(ScreenPath, {
                "module-name": "Quiz",
                "final-path": "Awards"
              }),
              _createElementVNode("img", {
                class: "award-img img-fluid",
                src: _unref(award).img,
                alt: "award-img"
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t(_unref(award).title)), 1),
              _createElementVNode("p", {
                innerHTML: _ctx.$t(_unref(award).description)
              }, null, 8, _hoisted_5),
              _createElementVNode("button", {
                class: "btn btn-md btn-primary",
                onClick: goToHome
              }, _toDisplayString(_ctx.$t('general.returnHomeScreen')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})